import script from "./DrawingCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingCapture.vue?vue&type=script&setup=true&lang=js"

import "./DrawingCapture.vue?vue&type=style&index=0&id=390a5f47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390a5f47"]])

export default __exports__